import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide14 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={13}
      total={total}
      label="Partner Path"
      kicker={t.kicker}
      onActive={onActive}
      bgStyle={{
        "--slide-bg": "linear-gradient(120deg,rgba(3,3,2,.96),rgba(1,2,1,.72)), repeating-linear-gradient(125deg, rgba(213,183,45,.7) 0 2px, transparent 2px 17px), radial-gradient(900px 600px at 28% 80%,rgba(218,186,44,.30),transparent 60%)"
      }}
    >

      <h2>{t.title}</h2>
      <p className="lead">{t.body}</p>

      <div className="flow">
        <div className="step"><b>01</b><span>{t.flow1}</span></div>
        <div className="step"><b>02</b><span>{t.flow2}</span></div>
        <div className="step"><b>03</b><span>{t.flow3}</span></div>
        <div className="step"><b>04</b><span>{t.flow4}</span></div>
        <div className="step"><b>05</b><span>{t.flow5}</span></div>
        <div className="step"><b>06</b><span>{t.flow6}</span></div>
      </div>

      <div className="side-stat">
        <div className="label">Positioning</div>
        <div className="val">One stop</div>
      </div>
      
      <div className="source-note">Emissor.PRO · Partner presentation · HTML scroll deck</div>
    </SlideShell>
  );
};





